'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '@/frontend/utils';
import { base, colors } from './checkboxStyles';
export type CheckboxColor = keyof typeof colors;
export interface CheckboxProps {
  color?: CheckboxColor;
  className?: string;
}
export function Checkbox(t0) {
  const $ = _c(15);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "algoprimary" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("group inline-flex focus:outline-hidden", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = colors[color];
  let t4;
  if ($[6] !== t3) {
    t4 = cn([base, t3]);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg aria-hidden="true" className="size-4 stroke-(--checkbox-check) opacity-0 group-data-checked:opacity-100 sm:h-3.5 sm:w-3.5" viewBox="0 0 14 14" fill="none"><path className="opacity-100 group-data-indeterminate:opacity-0" d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path className="opacity-0 group-data-indeterminate:opacity-100" d="M3 7H11" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <span className={t4}>{t5}</span>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== props || $[12] !== t2 || $[13] !== t6) {
    t7 = <Headless.Checkbox data-slot="control" {...props} className={t2}>{t6}</Headless.Checkbox>;
    $[11] = props;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}